import { component, prop } from '../../../decorators';

const HALF_CIRCLE = 180; // deg
const CIRCLE = 360; // deg
const HALF_PERCENTS = 50;

@component
export default class CircleProgressbar {
   @prop({ type: Number, required: true }) progress // %

   get left() {
      const part = this.progress > HALF_PERCENTS ?  this.progress : CIRCLE;
      return `${(HALF_CIRCLE * part/HALF_PERCENTS).toFixed()}deg`;
   }

   get right() {
      const part = Math.min(this.progress, HALF_PERCENTS);
      return `${(HALF_CIRCLE * part/HALF_PERCENTS).toFixed()}deg`;
   }

   get showLeftPart() {
      return this.progress > HALF_PERCENTS;
   }

   get showRightPart() {
      return !!this.progress;
   }
}
